import styled from "styled-components";
import logo from "./logo.png"

const Logo = styled.img`
  height: 30px;
  flex-grow: 0;
  object-fit: contain;
  margin-bottom: 4px;
`

export default () => (
    <Logo src={"/logo-고용노동부.png"} alt={"스파르타 코딩클럽"}/>
)
